/* eslint-disable no-dupe-keys */
import { CSSObject } from "styled-components"
import { FALLBACK_FONTS, BODY_SIZE, BODY_COLOR, REGULAR_FONT, BACKGROUND } from "../const"

const globalStyles: CSSObject = {
  body: {
    fontFamily: `${REGULAR_FONT.NAME}, ${FALLBACK_FONTS}`,
    fontSize: BODY_SIZE,
    fontWeight: REGULAR_FONT.WEIGHT,
    backgroundColor: BACKGROUND,
    color: BODY_COLOR,
    lineHeight: 1,
    fontFeatureSettings: `kern`,
    "& *": {
      scrollbarWidth: `thin`,
      scrollbarColor: `rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05)`,
      "&::-webkit-scrollbar": {
        width: `4px`,
        backgroundColor: `#E4E3DD`,
        borderRadius: `4px`,
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: `rgba(0, 0, 0, 0.2)`,
        borderRadius: `4px`,
      },
    },
    textRendering: `optimizeLegibility`,
    "-webkit-font-smoothing": `antialiased`,
    "-moz-osx-font-smoothing": `grayscale`,
    "& .mdc-data-table__table": {
      "@media (max-width: 600px)": {
        whiteSpace: `normal !important`,
      },
    },
    "& .rmwc-tooltip.rmwc-tooltip--in-modal": {
      zIndex: `18000 !important`,
    },
  },
}

export default globalStyles
